import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";

export const ClosingCTA = () => (
  <section
    data-testid="closing-cta-band"
    className="relative overflow-hidden bg-navy"
    aria-label="Ajakan menghubungi kami"
  >
    <div className="navy-grid-bg absolute inset-0" aria-hidden="true" />
    <div
      className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-orange-500/15 blur-3xl"
      aria-hidden="true"
    />
    <div
      className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl"
      aria-hidden="true"
    />
    <div
      className="absolute left-0 top-0 h-full w-1.5 bg-orange-500"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-24">
      <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
        <Reveal className="max-w-2xl">
          <h2 className="text-balance font-heading text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
            Punya Rencana Membangun atau{" "}
            <span className="italic text-orange-500">Merenovasi?</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">
            Ceritakan kebutuhan proyek Anda. Kami siap berdiskusi, memberikan
            gambaran biaya, dan membantu merencanakan langkah terbaik — tanpa
            kewajiban apa pun.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <a
            href="#kontak"
            data-testid="closing-cta-button"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("#kontak");
            }}
            className="group inline-flex items-center gap-2.5 rounded-full bg-orange-500 px-8 py-4 text-sm font-bold text-white shadow-2xl shadow-orange-500/30 transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-orange-600"
          >
            Hubungi Kami
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
